export default __webpack_public_path__ + "static/media/2021-12-28_17h21_47.e059a076.jpg";